import { CSSProperties } from "react";
import { useSelector } from "react-redux";
import { BasicTabs } from "../../components";

export interface RootState {
  top: {
    top: CSSProperties;
  };
}

const Account = () => {
  const checkTop = useSelector((state: RootState) => state.top.top);

  return (
    <section
      className="user-acct"
      style={checkTop}
    >
      <BasicTabs />
    </section>
  );
};

export default Account;
